import React, { useContext, useEffect, useRef, useState } from "react";
import "./PartRequestTabularInfo.css";
import { getPartRequestTabularInfo } from "../../../../Services/partRequestService";
import { HTTP_RESPONSE_CODES } from "../../../../../../globals/globals";
import { Sorting } from "../../../../../../components/Lists/Sorting";
import Input from "../../../../../../components/Inputs/Input";
import CheckboxField from "../../../../../../components/Checkbox/CheckboxField";
import { ResultsNotFound } from "../../../../../../components/ResultsNotFound/ResultsNotFound";
import Skeleton from "react-loading-skeleton";
import { PartRequestContext } from "../../../../context/PartRequestContext";
import { Tooltip } from "@mui/material";
import { DropdownsContext } from "../../../../../../contexts/DropdownsContext";
import Dropdowns from "../../../../../../components/Dropdowns/Dropdowns";
const dropdownIds = [133, 136];
const dropdownNames = {
  133: "internal_batch",
  136: "serialized_part_id_selected",
};
export const PartRequestTabularInfo = ({ item, open }) => {
  const {
    dropdownsData,
    setDropdownsData,
    setDropdownIds,
    dropdownDefaultOptions,
  } = useContext(DropdownsContext);
  const [partRequestDetails, setPartRequestDetails] = useState(null);
  const [informationLoading, setInformationLoading] = useState(true);
  const [sortingOrder, setSortingOrder] = useState("id");
  const didMount = useRef(false);
  const [maxPages, setMaxPages] = useState(null);
  const [page, setPage] = useState(0);
  const [extraParamas, _] = useState([
    { columnName: "companyId", value: localStorage.getItem("u_company_id") },
  ]);
  const {
    partsRequestToIssue,
    setPartsRequestToIssue,
    partsIssuedDate,
    typeRequestTab,
  } = useContext(PartRequestContext);

  const [displayForm, setDisplayForm] = useState(false);
  const pageSize = 10;
  const requestNextPage = () => {
    setPage((prev) => Math.min(prev + 1, maxPages - 1));
  };
  useEffect(() => {
    setDropdownIds(dropdownIds);
  }, []);
  useEffect(() => {
    if (dropdownsData && dropdownsData.length > 0) {
      setDisplayForm(true);
    }
  }, [dropdownsData]);
  useEffect(() => {
    if (open) {
      setInformationLoading(true);
      getPartRequestTabularInfo(page, pageSize, sortingOrder, "", item.PRN)
        .then((response) => {
          if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            setMaxPages(response.data.totalPages);

            let partRequestArray = response.data.load.map((item) => {
              let status = !item.available_quantity
                ? "error"
                : item.available_quantity >= item.remaining_quantity
                ? "success"
                : "warning";

              const alreadySelected = partsRequestToIssue.some(
                (i) => i.id === item.id
              );
              const issued = item.remaining_quantity <= 0;
              if (issued) {
                item.quantity_issue = 0;
                status = "issued";
              }
              const parameters = [
                {
                  columnName: "partId",
                  value: item.part_id,
                },
                {
                  columnName: "companyId",
                  value: localStorage.getItem("u_company_id"),
                },
                {
                  columnName: "locationId",
                  value: item.location_id,
                },
                {
                  columnName: "siteId",
                  value: item.site_id,
                },
                {
                  columnName: "batchId",
                  value: item.internal_batch,
                },
                {
                  columnName: "serializePartId",
                  value: item.serialized_part_id_selected,
                },
              ];
              return {
                ...item,
                status,
                toIssue: alreadySelected && item.quantity_issue > 0 && !issued,
                completeIssued: issued,
                parameters: parameters,
              };
            });

            setPartRequestDetails(partRequestArray);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setInformationLoading(false);
        });
    }
  }, [open, sortingOrder, partsIssuedDate]);

  const getSortingOrder = (order) => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    setSortingOrder(order);
  };

  const changeValue = (index, field, value) => {
    setPartRequestDetails((prev) => {
      const updated = [...prev];
      const currentItem = updated[index];

      if (field === "quantity_issue") {
        const numericValue = Number(value);
        const limitedValue = Math.min(
          numericValue,
          currentItem.available_quantity || 0,
          currentItem.remaining_quantity || 0
        );

        const newItem = {
          ...currentItem,
          quantity_issue: limitedValue,
          toIssue: limitedValue > 0 ? currentItem.toIssue : false,
        };
        updated[index] = newItem;
        if (newItem.toIssue === false) {
          setPartsRequestToIssue((prevList) =>
            prevList.filter((i) => i.id !== newItem.id)
          );
        }
      } else if (field === "toIssue") {
        if (currentItem.quantity_issue > 0) {
          const newItem = {
            ...currentItem,
            toIssue: value,
          };
          updated[index] = newItem;

          setPartsRequestToIssue((prevList) => {
            const exists = prevList.some((i) => i.id === newItem.id);
            if (value && !exists) {
              return [...prevList, newItem];
            } else if (!value && exists) {
              return prevList.filter((i) => i.id !== newItem.id);
            }
            return prevList;
          });
        }
      } else {
        updated[index] = {
          ...currentItem,
          [field]: value,
        };
      }

      return updated;
    });
  };
  const handleSelectAll = (checked) => {
    setPartRequestDetails((prev) => {
      const updated = prev.map((item) => {
        if (item.quantity_issue > 0) {
          return { ...item, toIssue: checked };
        }
        return item;
      });

      // Actualizar el contexto global
      setPartsRequestToIssue((prevList) => {
        if (checked) {
          // Agregar todos los válidos que no estén ya
          const itemsToAdd = updated.filter(
            (item) =>
              item.quantity_issue > 0 && !prevList.some((i) => i.id === item.id)
          );
          return [...prevList, ...itemsToAdd];
        } else {
          // Remover todos los que estén en la lista actual
          const idsToRemove = updated
            .filter((item) => item.quantity_issue > 0)
            .map((item) => item.id);
          return prevList.filter((item) => !idsToRemove.includes(item.id));
        }
      });

      return updated;
    });
  };
  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };
  const resetDropdownsReload = () => {
    setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };
  const handleDropdownValue = (value, name, data, item) => {
    changeValueDrop(
      { target: { name, value: value[data], completeValue: value } },
      item
    );
  };
  const changeValueDrop = (e, item) => {
    const { name, value, completeValue } = e.target;
    const idx = partRequestDetails.findIndex((i) => i.id === item.id);
    if (idx === -1) return;
    if (name == "serialized_part_id_selected") {
      var internalBatch = completeValue["vw.internal_batch"];
      partRequestDetails[idx]["internal_batch"] = internalBatch;
      partRequestDetails[idx]["rack_id"] = completeValue["vw.rack_id"];
      partRequestDetails[idx]["shelf_id"] = completeValue["vw.shelf_id"];
      partRequestDetails[idx]["bin_id"] = completeValue["vw.bin_id"];
      partRequestDetails[idx]["available_quantity"] =
        completeValue["vw.quantity"];
    } else if (name == "internal_batch") {
      partRequestDetails[idx]["rack_id"] = completeValue["vw.rack_id"];
      partRequestDetails[idx]["shelf_id"] = completeValue["vw.shelf_id"];
      partRequestDetails[idx]["bin_id"] = completeValue["vw.bin_id"];
      partRequestDetails[idx]["available_quantity"] =
        completeValue["vw.quantity"];
    }
    partRequestDetails[idx][name] = value;
    setPartRequestDetails([...partRequestDetails]);
  };


  return (
    <div className="part-request-body">
      <div className="grid-request-detail-header">
        <Sorting
          onOrderChange={getSortingOrder}
          ignoreProperties={true}
          showHeaderOrder={true}
          displayButton={false}
          displayColumn={true}
          properties={{
            status: "Status",
            reference_type: "Type",
            reference_id: "Cod",
            part_number: "PN",
            site: "Site",
            internal_batch: "Assigned Batch",
            serialized_part_id_selected: "Assigned SN",
            quantity: "QTY Requested",
            issued_quantity_posted: "QTY Issued",
            available_quantity: "Available",
            quantity_issue: "QTY to Issue",
            uom_name: "UOM",
          }}
        ></Sorting>

        <CheckboxField
          disabled={false}
          outlined
          checked={
            partRequestDetails?.some((item) => item.quantity_issue > 0) &&
            partRequestDetails?.every(
              (item) => item.quantity_issue <= 0 || item.toIssue
            )
          }
          onChange={(checked) => handleSelectAll(checked)}
        >
          <span>Select All</span>
        </CheckboxField>
      </div>
      <div className="grid-view-body">
        <div className="grid-view-body-list">
          {informationLoading ? (
            Array.from({ length: 7 }).map((_, idx) => (
              <div key={idx} className="item-grid-skeleton">
                <Skeleton
                  style={{ borderRadius: "10px", marginBottom: "0.15rem" }}
                  height="1.5rem"
                  width="1.5rem"
                />
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>

                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
                <div className="item-skeleton-content">
                  <Skeleton height={20} width="100%" />
                </div>
              </div>
            ))
          ) : !partRequestDetails || partRequestDetails.length === 0 ? (
            <ResultsNotFound />
          ) : (
            partRequestDetails?.map((task, idx) => (
              <React.Fragment key={`${task.id}-${idx}`}>
                <div
                  className={`grid-view-row ${
                    task.completeIssued ? "complete-issued" : ""
                  }`}
                >
                  <div className={`part-request-status ${task.status}`}>
                    <i className={`icon-${task.status}`}></i>
                  </div>
                  <div className="part-request-info">
                    <div className="part-request-icon">
                      <i className="icon-task_icon_partRequest"></i>
                      <p>TC</p>
                    </div>
                    <Tooltip arrow title={task.reference_description}>
                      <p className="detail-task-number">{task.reference_id}</p>
                    </Tooltip>

                    <i className="icon-arrow-down"></i>
                  </div>
                  <div className="part-request-info">
                    <p className="detail-part-number">{task.part_number}</p>

                    <i className="icon-arrow-down"></i>
                  </div>
                  <div className="part-request-info">
                    <p>{task.site_name ?? "N/A"} </p>
                    <i className="icon-arrow-down"></i>
                  </div>
                  <>
                    {!displayForm ? (
                      <Skeleton height={"1.5rem"} width={"100%"} />
                    ) : (
                      <Dropdowns
                        context={{
                          dropdownsData,
                          setDropdownsData,
                          setDropdownIds,
                          dropdownDefaultOptions,
                        }}
                        updateDropdown={updateDropdown}
                        resetDropdownsReload={resetDropdownsReload}
                        hideErrorLabel={true}
                        hideLabel={true}
                        required={true}
                        disabled={
                          task.part_type == "Serialized" || task.completeIssued
                        }
                        key={133}
                        onOptionSelect={(value, data) =>
                          handleDropdownValue(
                            value,
                            dropdownNames[133],
                            data,
                            task
                          )
                        }
                        hideRequiredLabel={true}
                        parameters={task.parameters}
                        showPagination={false}
                        data={dropdownsData.find((e) => e.id === 133)}
                        preSelectValue={task.internal_batch}
                      />
                    )}
                  </>

                  {!displayForm ? (
                    <Skeleton height={"1.5rem"} width={"100%"} />
                  ) : (
                    <Dropdowns
                      context={{
                        dropdownsData,
                        setDropdownsData,
                        setDropdownIds,
                        dropdownDefaultOptions,
                      }}
                      updateDropdown={updateDropdown}
                      resetDropdownsReload={resetDropdownsReload}
                      hideErrorLabel={true}
                      hideLabel={true}
                      required={true}
                      disabled={
                        task.part_type != "Serialized" || task.completeIssued
                      }
                      key={136}
                      onOptionSelect={(value, data) =>
                        handleDropdownValue(
                          value,
                          dropdownNames[136],
                          data,
                          task
                        )
                      }
                      hideRequiredLabel={true}
                      parameters={task.parameters}
                      showPagination={false}
                      data={dropdownsData.find((e) => e.id === 136)}
                      preSelectValue={task.serialized_part_id_selected}
                    />
                  )}

                  <div className="part-request-info numberField">
                    <p>{task.quantity}</p>
                  </div>
                  <div className="part-request-info numberField">
                    <p>{task.issued_quantity_posted}</p>
                  </div>
                  <div className="part-request-info numberField">
                    <p>{task.available_quantity ?? 0}</p>
                  </div>
                  <Input
                    disabled={task.completeIssued}
                    name="quantity_issue"
                    isNumeric={true}
                    onChange={(e) =>
                      changeValue(idx, "quantity_issue", e.target.value)
                    }
                    onKeyDown={(e) => {
                      if (
                        e.key === "Enter" &&
                        Number(task.quantity_issue) > 0
                      ) {
                        changeValue(idx, "toIssue", true);
                      }
                    }}
                    disableAutocomplete={true}
                    label={""}
                    value={task.quantity_issue ?? 0}
                  />
                  <div className="part-request-info">
                    <p>{task.uom_name}</p>
                    <i className="icon-arrow-down"></i>
                  </div>
                  <CheckboxField
                    disabled={task.completeIssued}
                    outlined
                    checked={task.toIssue || task.completeIssued}
                    onChange={(e) => changeValue(idx, "toIssue", e)}
                  >
                    {typeRequestTab === "Workpackage" ? (
                      <span>{task.completeIssued ? "Issued" : "Issue"}</span>
                    ) : typeRequestTab === "Transfer" ? (
                      <span>
                        {task.completeIssued ? "Transferred" : "Transfer"}
                      </span>
                    ) : null}
                  </CheckboxField>
                </div>
              </React.Fragment>
            ))
          )}
        </div>
      </div>
    </div>
  );
};
